/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, TextField } from "@mui/material";
import { calculateDistanceMatrix, searchDistanceMatrices } from "../../api/apiCall";
import { useAuth } from "../../auth/auth";
import { useForm } from "react-hook-form";

const LocationMatrices = () => {
    const { state } = useAuth();
    const [workers, setWorkers] = useState<any>([]);

    const {register, handleSubmit, watch} = useForm<any>({
        defaultValues: {
            originPostCode: "",
            destinationPostCode: "",
        }
    })

    const watchFields = watch();

    const getWorkers = async (data: any) => {
        const response: any = await searchDistanceMatrices(state.user?.token, data.originPostCode, data.destinationPostCode);
        setWorkers(response)
    }

    const calculateDistance = async (data: any) => {
        const response: any = await calculateDistanceMatrix(state.user?.token, data.originPostCode, data.destinationPostCode);
        getWorkers(watchFields)
    }

    const columns: any = [
        {
            field: "originPostCode",
            headerName: "Origin",
            flex: 1.3,
        },
        {
            field: "destinationPostCode",
            headerName: "Destination",
            flex: 1.3,
        },
        {
            field: "distanceText",
            headerName: "Distance (Km)",
            flex: 1,
        },
        {
            field: "distanceValue",
            headerName: "Distance (Miles)",
            flex: 1,
            renderCell: (params: any) => (
                <div>
                    {(params.row.distanceValue / 1609.344).toFixed(1)}
                </div>
            ),
        },
        {
            field: "durationText",
            headerName: "Duration",
            flex: 1,
        },
    ];

    useEffect(() => {
        setTimeout(() => {
            getWorkers(watchFields)
        }, 500)
    }, [watchFields.originPostCode, watchFields.destinationPostCode])
    
    useEffect(() => {
        getWorkers({});
    }, []);

    return (
        <>
            <div className="form-content">
                <TextField
                    label="Origin Post Code"
                    type="text"
                    size="small"
                    {...register("originPostCode")}
                    style={{width: "15%", margin: 10}} />
                <TextField
                    label="Destination Post Code"
                    type="text"
                    size="small"
                    {...register("destinationPostCode")}
                    style={{width: "15%", margin: 10}} />
                <Button
                    variant="contained"
                    onClick={handleSubmit(getWorkers)}
                    style={{height: 40, margin: 10, boxShadow: 'none', width: "10%"}}>
                        Filter
                </Button>
                {workers.length === 0 && watchFields.originPostCode !== '' && watchFields.destinationPostCode !== '' &&
                    <Button
                        variant="contained"
                        onClick={handleSubmit(calculateDistance)}
                        style={{height: 40, margin: 10, boxShadow: 'none', width: "10%", backgroundColor: 'green'}}>
                        Add New Post Code
                    </Button>
                }
            </div>
            <Box sx={{height: "800px", width: "70%", margin: '0 auto'}} mt={3}>
                <DataGrid
                    rows={workers}
                    columns={columns}
                    disableRowSelectionOnClick
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 100,
                            },
                        },
                    }}
                    pageSizeOptions={[100]}
                    sx={{
                        "& .MuiDataGrid-columnHeaderTitle": {
                            fontWeight: "bold",
                            fontSize: 15
                        },
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: '#f0f0f0',
                            color: "#000",
                            fontWeight: "bold",
                        },
                        '& .disable-columns': {
                            borderRight: '1px solid #bfbfbf'
                        },
                        '& .border-left': {
                            borderLeft: '1px solid #bfbfbf',
                        },
                    }}
                />
            </Box>
        </>
    );
};

export default LocationMatrices;
